import { render } from "./ProfileThemeSix.vue?vue&type=template&id=77be4aa0"
import script from "./ProfileThemeSix.vue?vue&type=script&lang=js"
export * from "./ProfileThemeSix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/themes/old_layouts/ProfileThemeSix.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77be4aa0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77be4aa0', __exports__)) {
    api.reload('77be4aa0', __exports__)
  }
  
  module.hot.accept("./ProfileThemeSix.vue?vue&type=template&id=77be4aa0", () => {
    api.rerender('77be4aa0', render)
  })

}


export default __exports__